export const examAdminDashboard = {
  pageTitle: "プラットフォーム概要",
  pageSubtitle: "問題、試験用紙、試験の 3 つの主要ワークフローを中心にした管理ポータルです。",
  superAdminSubtitle:
    "スーパー管理者向けの運用ダッシュボード。全体進捗、リスク、未処理事項を集約します。",
  stats: {
    questionsTotal: "問題総数",
    papersTotal: "試験用紙総数",
    examsTotal: "試験総数",
    runningExams: "実施中の試験",
    upcomingExams: "24 時間以内に開始",
    endedPendingArchive: "アーカイブ待ち",
    questionsHelper: "下書き問題 {count} 件",
    papersHelper: "下書き試験用紙 {count} 件",
    examsHelper: "下書き試験 {count} 件",
    runningHelper: "現在進行中の試験件数",
    upcomingHelper: "次の 24 時間以内に開始予定の試験",
    endedHelper: "終了済みで、まだ整理やアーカイブが必要な試験",
  },
  focusTitle: "重点項目",
  focusTag: "Core",
  focusItems: {
    roleAware:
      "1. 現在のログインロールは {role} です。管理画面のページと API はロール単位で制御されています。",
    rbac: "2. 問題、試験用紙、試験、採点、実行管理は役割ごとに分割されています。ボタン単位の権限は業務方針に応じて調整します。",
    priority:
      "3. 作成・閲覧・検証の主要フローに焦点を置き、承認フローや詳細権限は業務方針に沿って扱います。",
  },
  recentExamsTitle: "最近の試験",
  recentExamsItem: "試験用紙バージョン {paperVersionLabel} · {createdAt}",
  recentExamsEmpty: {
    noExams: "まだ試験は作成されていません",
    noPermission: "現在のロールでは試験一覧を表示しません",
  },
  heroTag: "Super Admin",
  heroTitle: "システム運用コックピット",
  heroDescription:
    "問題、試験用紙、試験の主要ワークフローを 1 つの作業台に集約し、リスク、滞留、緊急対応を優先表示します。",
  heroSideTitle: "優先アラート",
  headerActions: {
    createQuestion: "問題を新規作成",
    createExam: "試験を新規作成",
  },
  tasksTitle: "対応が必要な項目",
  tasksTag: "Action Queue",
  tasks: {
    draftQuestions: "下書き問題",
    draftQuestionsHelper: "下書き問題の内容と公開状態を優先して整備します",
    draftPapers: "下書き試験用紙",
    draftPapersHelper: "作成進捗を確認し、下書きのまま放置しないようにします",
    draftExams: "公開待ちの試験",
    draftExamsHelper: "設定確認後すぐ公開し、日程遅延を防ぎます",
    runningExams: "実施中の試験",
    runningExamsHelper: "実施状況、監督、異常フィードバックを確認します",
    endedExams: "終了済み・未整理",
    endedExamsHelper: "終了後は早めにアーカイブして状態を整理します",
    upcomingExams: "まもなく開始する試験",
    upcomingExamsHelper: "時間枠、試験用紙、監督設定を事前確認します",
  },
  activityTitle: "最近の更新",
  activityTag: "Timeline",
  activityActor: "操作ユーザー: {name}",
  activityKinds: {
    question: "問題",
    paper: "試験用紙",
    exam: "試験",
  },
  risksTitle: "リスクと注意事項",
  risksTag: "Attention",
  risks: {
    examStartingSoonTitle: "1 時間以内に開始する試験があります",
    examStartingSoonDescription: "「{name}」は {time} に開始予定です。最終確認を完了してください。",
    examEndingSoonTitle: "2 時間以内に終了する実施中試験があります",
    examEndingSoonDescription:
      "「{name}」は {time} に終了予定です。提出状況と採点の収束を確認してください。",
    oldDraftQuestionTitle: "長期間停滞している下書き問題があります",
    oldDraftQuestionDescription:
      "「{name}」は {time} に作成されました。継続するか整理するか判断してください。",
    oldDraftPaperTitle: "長期間停滞している下書き試験用紙があります",
    oldDraftPaperDescription:
      "「{name}」は {time} に作成されました。早めに完成させるかアーカイブしてください。",
    stableTitle: "現時点で高優先度のリスクはありません",
    stableDescription: "問題、試験用紙、試験の主要フローは全体として安定しています。",
  },
  quickActionsTitle: "クイックアクセス",
  quickActionsTag: "Quick Access",
  quickActions: {
    createQuestionTitle: "問題を新規作成",
    createQuestionDescription: "問題作成ドロワーを開いて問題バンクを拡充します。",
    createPaperTitle: "試験用紙を新規作成",
    createPaperDescription: "試験用紙の作成を始め、構成を整えます。",
    createExamTitle: "試験を新規作成",
    createExamDescription: "時間、試験用紙バージョン、ルールを設定して試験を開始します。",
    goQuestionsTitle: "問題センターへ",
    goQuestionsDescription: "一覧、下書き、アーカイブ状態を確認します。",
    goPapersTitle: "試験用紙センターへ",
    goPapersDescription: "バージョン、アーカイブ、作成進捗を管理します。",
    goExamsTitle: "試験センターへ",
    goExamsDescription: "状態、アーカイブ、運営指標をまとめて確認します。",
    goSystemSettingsTitle: "システム管理へ",
    goSystemSettingsDescription: "サイト設定、セキュリティ方針、AI 連携設定を確認します。",
    goAuditLogsTitle: "監査ログへ",
    goAuditLogsDescription: "重要操作とログイン履歴を追跡します。",
  },
  viewNow: "今すぐ確認",
};
